/**
 * ActionListSkeleton — loading placeholder rows matching the action-list row
 * layout (avatar + title + description + timestamp). Shared by the Open list
 * and the Done/Dismissed/Archived history views so every AI Actions tab has
 * the identical loading treatment (one implementation, not copied classes).
 */

const SKELETON_ROWS = [1, 2, 3, 4, 5];

export function ActionListSkeleton() {
  return (
    <div className='flex flex-col'>
      {SKELETON_ROWS.map(i => (
        <div
          key={i}
          className='flex items-start border-t border-[var(--color-border-secondary)] min-h-[64px] px-[16px] py-[10px]'
        >
          {/* Avatar skeleton */}
          <div className='w-[26px] h-[26px] rounded-full bg-bg-tertiary animate-pulse flex-shrink-0 mt-[2px]' />
          {/* Content skeleton - flex-1 to fill remaining width like text naturally does */}
          <div className='pl-[12px] pr-[4px] min-w-0 flex-1'>
            {/* Title skeleton - titles fill most/all of the width */}
            <div className='h-[20px] bg-bg-tertiary rounded animate-pulse w-full' />
            {/* Description skeleton - truncated text fills most of line */}
            <div className='h-[18px] bg-bg-tertiary rounded animate-pulse w-3/4 mt-[2px]' />
            {/* Timestamp skeleton - "Created X ago" is short */}
            <div className='h-[16px] bg-bg-tertiary rounded animate-pulse w-1/3 mt-[6px]' />
          </div>
        </div>
      ))}
    </div>
  );
}
